export default __webpack_public_path__ + "static/media/synesthesiaAtt1.6cf33587.png";